import React, { useState, useEffect, useCallback } from "react";
import "../componentCss/ReportRevenueDistribution.css";
import excluir from "../../assets/img/removerWhite.svg";
import Swal from "sweetalert2";
import Menu from "../../components/Menu.js";
import { useNavigate } from "react-router-dom";
import api from "../../api.js";
import { useStateContext } from "../../contexts/ContextProvider.js";

// Funções utilitárias fora do componente
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("pt-BR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const formatCurrency = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

const formatMonth = (monthString) => {
  if (!monthString || !/^\d{4}-\d{2}$/.test(monthString)) return "";
  const [year, month] = monthString.split("-");
  return new Date(year, month - 1, 1).toLocaleString("pt-BR", {
    month: "long",
    year: "numeric",
  });
};

const DoctorTransfer = () => {
  const [description, setDescription] = useState("");
  const [dataRepasse, setDataRepasse] = useState("");
  const [payments, setPayments] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const { user } = useStateContext();
  const hasPermission = user.user.cashier_supervisor;

  const calculateTotalRevenue = useCallback((list) => {
    const total = list.reduce((sum, p) => sum + Number(p.total_amount), 0);
    setTotalRevenue(total);
  }, []);

  const fetchPayments = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.post("api/fund-transfers/date-range", {
        description: description || null,
        yearmount: dataRepasse || null,
        type: "S", // médicio solicitante
      });

      const data = response.data.data;
      console.log("Filtro: ", data);
      setPayments(data);
      calculateTotalRevenue(data);
    } catch (err) {
      console.error("Erro ao buscar pagamentos:", err);
      setError("Erro ao buscar dados. Verifique as datas e tente novamente.");
    } finally {
      setLoading(false);
    }
  }, [description, calculateTotalRevenue, dataRepasse]);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Deseja cancelar o pagamento?",
      text: "Esta ação não pode ser desfeita.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, cancelar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.post("api/fund-transfers/destroy", {
            id,
            type: "S", // médicio solicitante
          });

          Swal.fire({
            title: "Cancelado!",
            text: "Pagamento cancelado com sucesso.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top'
          })

          await fetchPayments(); // recarrega os dados após exclusão
        } catch (err) {
          console.error("Erro ao excluir pagamento:", err);
          setError("Erro ao excluir pagamento. Tente novamente.");
        }
      }
    });
    navigate("/financial/repasse-medico");
  };

  useEffect(() => {
    fetchPayments(); // carregamento inicial
  }, []);

  return (
    <Menu
      screen={
        <div className="container-fluid report-container">
          <div className="report-header">
            <h1 className="report-title h2">
              Repasse - Médico Solicitante
            </h1>
            <button
              className="btn add-payment-btn"
              style={{
                backgroundColor: "#3498db",
                color: "white",
                fontWeight: "bold",
                fontSize: "26px",
                padding: "10px 20px",
                borderRadius: "36px",
              }}
              onClick={() => navigate("/financial/repasse-medico/novo")}>
              +
            </button>
          </div>

          <div className="card mb-4 filter-section">
            <div className="card-header">Filtros de Pesquisa</div>
            <div className="card-body">
              <div className="row g-3 align-items-end">
                <div className="col-md-4">
                  <label className="form-label">Descrição:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={description}
                    onChange={(e) => {
                      e.preventDefault();
                      setDescription(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Data de Repasse:</label>
                  <input
                    type="month"
                    className="form-control"
                    value={dataRepasse}
                    onChange={(e) => {
                      e.preventDefault();
                      setDataRepasse(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <button
                    className="btn btn-primary me-2"
                    onClick={() => fetchPayments(true)}
                    disabled={loading}>
                    {loading ? "Carregando..." : "Pesquisar"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="container-reports">
            <div className="container-reports-content">
              {loading && (
                <div className="alert alert-info text-center">
                  Carregando dados...
                </div>
              )}

              {error && (
                <div className="alert alert-danger text-center">{error}</div>
              )}

              {!loading &&
                !error &&
                (payments.length > 0 ? (
                  payments.map((payment) => (
                    <div
                      className="component-pagamento"
                      key={payment.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `/financial/repasse-medico/${payment.id}`
                        )
                      }>
                      <p>
                        <strong>Data Inicial:</strong> {formatDate(payment.start_date)}
                      </p>
                      <p>
                        <strong>Data Final:</strong> {formatDate(payment.end_date)}
                      </p>
                      <p>
                        <strong>Mês do Repasse:</strong>{" "}
                        {formatMonth(payment.transfer_month)}
                      </p>
                      <p>
                        <strong>Valor Total:</strong>{" "}
                        {formatCurrency(payment.total_amount)}
                      </p>
                      <p>
                        <strong>Descrição:</strong> {payment.description}
                      </p>

                      {hasPermission && (
                        <div>
                          <button
                            className="btn btn-danger me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(payment.id);
                            }}>
                            <img width={30} src={excluir} alt="Excluir" />
                          </button>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="alert alert-info text-center">
                    Nenhum pagamento encontrado no período selecionado.
                  </div>
                ))}
            </div>

            {payments.length > 0 && !loading && (
              <div className="total-revenue text-end mt-3">
                Total: {formatCurrency(totalRevenue)}
              </div>
            )}
          </div>
        </div>
      }
    />
  );
};

export default DoctorTransfer;
